export default class SlotSymbol {
	constructor(scene, sprite, blurTexture, posY, frameRate) {
		this.scene = scene;
		this.sprite = sprite;
		this.sprite.depth = -1;
		this.normalTexture = sprite.texture;
		this.blurTexture = blurTexture;
		this.posY = posY;
		this.orderOnReel = 0;
		this.sprite.setPosition(this.sprite.x, Math.round(this.posY));
		//this.sprite.setVisible(false);
		this.frameRate = frameRate;
		// create symbols animation
		this.symbolAnim = this.scene.anims.create({
			key: this.sprite.name + 'anim',
			frames: this.scene.anims.generateFrameNumbers(this.sprite.name + 'Sheet'),
			frameRate: this.frameRate,
			repeat: -1
		});
		this.anim = null;
		this.blur = false;
		this.posX = this.sprite.x;
	}

	setPositionY(posY) {
		this.posY = posY;
		this.sprite.setPosition(this.posX, Math.round(this.posY));
	}

	setIcon(icon) {
		this.sprite.setTexture(this.blur ? this.blurTexture : this.normalTexture);
		this.sprite.name = icon;
	}

	showAnim(show) {
		if (show) {
			if (this.anim == null) {
				this.sprite.setVisible(false);
				this.anim = this.scene.add
					.sprite(this.sprite.x, this.posY, this.sprite.name + 'Sheet')
					.setOrigin(0.5)
					.play({ key: this.sprite.name + 'anim' }); // , frameRate : this.frameRate
				this.anim.depth = 10;
			}
		} else {
			this.sprite.setVisible(true);
			if (this.anim !== null) {
				this.anim.stop();
				this.anim.destroy();
			}
			this.anim = null;
		}
	}

	setBlur(blur) {
		if (this.blur === blur) return;
		this.blur = blur;
		this.sprite.setTexture(blur ? this.blurTexture : this.normalTexture);
	}

	setVisible(visible) {
		this.sprite.setVisible(visible);
	}
}
